import React, { useCallback, useRef } from 'react';
import { string, func } from 'prop-types';
import { connect } from 'react-redux';
import { Button, XMarkIcon } from '@snapask/common-components';

import { actions } from '@dragonfruit/redux/socialWidget';
import { closePromotionBanner } from '@dragonfruit/redux/promotionBanner';
import eve from './images/Promotion_banner_Eve.svg';
import styles from './PromotionBanner.scss';

function PromotionBanner({
  btnText,
  descr,
  onClick,
  setSocialWidgetProps,
  closePromotionBanner,
}) {
  const bannerRef = useRef();
  const bannerHeightRef = useRef();

  const closeBanner = useCallback(() => closePromotionBanner(), [
    closePromotionBanner,
  ]);

  const changeSocialWidgetStyle = () => {
    const height = bannerRef.current.offsetHeight;
    setSocialWidgetProps({
      bottomDistance: bannerRef.current.offsetHeight,
    });
    bannerHeightRef.current = height;
  };

  const getBannerRef = ref => {
    if (bannerRef.current) return;
    bannerRef.current = ref;
    // wait for the correct height to be detected
    setTimeout(() => {
      changeSocialWidgetStyle();
    }, 2000);
  };

  return (
    <section className={styles.root} ref={getBannerRef}>
      <div className={styles.bannerContent}>
        <img src={eve} className={styles.eve} />
        <span className={styles.description}>{descr}</span>
        <Button text={btnText} onClick={onClick} small theme={styles} />
      </div>
      <div className={styles.icon}>
        <XMarkIcon
          width={24}
          height={24}
          className={styles.closeIcon}
          onClick={closeBanner}
        />
      </div>
    </section>
  );
}

PromotionBanner.propTypes = {
  btnText: string.isRequired,
  closePromotionBanner: func.isRequired,
  descr: string.isRequired,
  setSocialWidgetProps: func.isRequired,
  onClick: func.isRequired,
};

export default connect(null, {
  closePromotionBanner,
  setSocialWidgetProps: actions.setSocialWidgetProps,
})(PromotionBanner);



// WEBPACK FOOTER //
// ./app/components/PromotionBanner/PromotionBanner.jsx